import PageContentSliceMapper from './pageContentSliceMapper';

export default PageContentSliceMapper;
